import * as _ from 'lodash'
import React, { useEffect, useState } from 'react';
import { IJobCostChildProps } from 'Scripts/components/jobCostEdit';
import { PercentInput, Radio } from 'Scripts/components/sharedComponents';
import componentServices from 'Scripts/componentServices';
import globalRelay from 'Scripts/globalRelay';
import { getModel, ModelCollection } from 'Scripts/store';
import valueFilters from 'Scripts/valueFilters';
import enums from 'Scripts/enum'


//TODO: this should probably be cleaned up at some point
export function JobCostSetupRowsComponent({ jobCost, updateModel}: Pick<IJobCostChildProps, 'jobCost' | 'updateModel'>) {
	const currentEmployee = componentServices.securityContext.getCurrentEmployee();
	const variantValue = jobCost.companyVariant || (currentEmployee && currentEmployee.getProfileValue('defaultCompanyVariant'));
	const globalConfig = globalRelay.config!.withVariant(variantValue);
	const setupConfig = globalConfig.jobCostSettings.setup;
	const rows = [];
	const [settingConfigItems, setSettingConfigItems] = useState({});
	useEffect(() => {
		if (setupConfig && setupConfig.editableSettings) {
			const editableSettings = globalRelay.filterState('editableSettings', { jobCost }, setupConfig.editableSettings);

			_.forEach(editableSettings, (settingConfig, key) => {
				switch (settingConfig.type) {
				case 'select': {
					const configItemsKey = key;
					if (settingConfig.dataAccessor) {
						globalRelay.executeGlobalFunction(settingConfig.dataAccessor, { jobCost: jobCost })
							.then(result => {
								setSettingConfigItems(previousState => {
									const newState = _.assign({}, previousState);

									newState[configItemsKey] = result;

									return newState;
								});
							});
					}

					break;
				}

				default:
				}
			});
		}
	}, [jobCost, setupConfig]);

	function updateSetting(name, autoSave, e) {
		// e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		updateModel((model, childUpdateCallback) => {
			const setting = model.setSetting(enums.jobCostSettingGroups.General, name, undefined, newVal);

			if (setting) {
				childUpdateCallback(setting);
			}
		}, { autoSave: autoSave, updatePath: 'settings' });
	}

	function handleUpdate(path, autoSave, e) {
		e.preventDefault();

		const newVal = (autoSave) ? valueFilters.clean(e.target.value) : e.target.value;

		updateModel(model => {
			const updateTarget = model.currentChangeOrder || model;

			updateTarget.setAt(path, newVal);

			// default the variant based on the employee profile value
			if (!model.companyVariant) {
				model.companyVariant = currentEmployee && currentEmployee.getProfileValue('defaultCompanyVariant');
			}
		}, { autoSave: autoSave, updatePath: path });
	}

	rows.push(<tr key="margin" className={!jobCost.margin ? 'required' : ''}>
		<td />
		<td><strong>Default Margin (%)</strong></td>
		<td><PercentInput placeholder="" autoCapitalize="" autoCorrect="off" value={jobCost.viewValue('margin')} onChange={e => handleUpdate('margin', false, e)} onBlur={e => handleUpdate('margin', true, e)} /></td>
		<td />
	</tr>);

	if (setupConfig && setupConfig.editableSettings) {
		const editableSettings = globalRelay.filterState('editableSettings', { jobCost }, setupConfig.editableSettings);

		_.forEach(editableSettings, (settingConfig, key) => {
			const value = jobCost.getSettingValue(enums.jobCostSettingGroups.General, key, undefined, settingConfig.defaultValue || '');
			let input;
			let items;

			switch (settingConfig.type) {
			case 'percent':
				input = <PercentInput placeholder="" autoCapitalize="" autoCorrect="off" value={value} onChange={e => updateSetting(key, false, e)} onBlur={e => updateSetting(key, true, e)} />;
				break;
			case 'select':
				items = settingConfig.items || settingConfigItems[key];

				if (items) {
					if (value && !_.find(items, { value: value })) {
						items.push({ value: value });
					}

					const options = _.map(items, item => <option key={item.value} value={item.value}>{item.label || item.value}</option>);

					input = <select className="select" placeholder="Select" value={value} onChange={e => updateSetting(key, true, e)}>{options}</select>;
				}
				break;
			case 'boolean':
				input = (<Radio buttons={[
					{ classNames: ['icon yes'], isSelected: (value === '1'), value: '1' },
					{ classNames: ['icon no'], isSelected: (value === '0'), value: '0' }
				]} onChange={(newButton) => updateSetting(key, true, { target: newButton })} />);
				break;
			default:
				input = <input type="text" placeholder="" autoCapitalize="" autoCorrect="off" value={value} onChange={e => updateSetting(key, false, e)} onBlur={e => updateSetting(key, true, e)} />;
			}
			rows.push(<tr key={ `setting-${key}`} className={ (settingConfig.required && !value) ? 'required' : ''}>
				<td />
				<td><strong>{settingConfig.label}</strong></td>
				<td>{input}</td>
				<td />
			</tr>);
	
			if(key === 'taxJurisdiction'){
				const { store } = componentServices;
				const currentEmployee = componentServices.securityContext.getCurrentEmployee();
				const variantValue = jobCost.companyVariant || (currentEmployee && currentEmployee.getProfileValue('defaultCompanyVariant'));
				const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
				const globalConfig = globalRelay.config!.withVariant(variantValue);
				const taxConfig = globalConfig.jobCostSettings.tax;
				const jurisdictions = taxConfig.jurisdictions;
				const taxJurisdiction = _.find(jurisdictions, { name: value });
				const taxRateSetting = jobCost.getSetting(enums.jobCostSettingGroups.General, 'taxRate')
				const isTaxExempt = taxJurisdiction && taxJurisdiction.requiresTaxExemptContractor;
				const isCustomTax = taxJurisdiction && taxJurisdiction.custom;

				let adjustedTaxRate = Number(taxRateSetting.value || '0');
				
				if (jobCost.isSupplyOnly) {
					const supplyOnlyJurisdiction = _.find(jurisdictions, { supplyOnlyJurisdiction: variantValue });
					if (supplyOnlyJurisdiction) {
						adjustedTaxRate = supplyOnlyJurisdiction.rate
						// jobCost.setSetting(enums.jobCostSettingGroups.General, 'taxJurisdiction', undefined, supplyOnlyJurisdiction.name);
						if(isCustomTax){
							jobCost.setSetting(enums.jobCostSettingGroups.General, 'taxRate', undefined, supplyOnlyJurisdiction.rate || 0);
						}
					}
				}
				else if(!isTaxExempt && !jobCost.isSupplyOnly && job && !job.builderKey && !job.isRenovation && !isCustomTax){
					adjustedTaxRate *= taxConfig.newHomeFactor
				}

				rows.push(<tr key={`setting-taxRate`} className={!isCustomTax || jobCost.isSupplyOnly ? 'disabled' : (/*doesnt work -> make sure validator is created properly*/!taxRateSetting?.value) ? 'required' : ''}>
					<td />
					<td><strong>Tax Rate (%)</strong></td>
					<td><PercentInput placeholder="" autoCapitalize="" autoCorrect="off" value={adjustedTaxRate} onChange={e => updateSetting('taxRate', false, e)} onBlur={e => updateSetting('taxRate', true, e)} /></td>
					<td />
				</tr>);
			}
		});
	}

	return <React.Fragment>{rows}</React.Fragment>
}
